<header class="myce-utility-bar" role="banner">
  <div class="myce-utility-bar__inner">

    <!-- Logo -->
    <a class="myce-utility-bar__logo" [routerLink]="'/' | langLink"
      aria-label="My Classroom Economy powered by Vanguard — Home">
      <!-- xs / sm / md: compact logo -->
      <img src="/assets/images/websitelogo_xs-md.svg"
        class="myce-utility-bar__logo-img myce-utility-bar__logo-img--xs-md" alt="" aria-hidden="true" />
      <!-- lg / xl / xxl: full logo -->
      <img src="/assets/images/websitelogo_l-xxl.svg" class="myce-utility-bar__logo-img myce-utility-bar__logo-img--lg"
        alt="" aria-hidden="true" />
    </a>

    <!-- Right-side global functions -->
    <nav class="myce-utility-bar__actions" aria-label="Utility navigation">
      <ul class="myce-utility-bar__action-list" role="list">

        <!-- Contact us -->
        <li class="myce-utility-bar__action-item">
          <a [routerLink]="'/aboutus' | langLink" [queryParams]="{contact: 'true'}"
            class="myce-utility-bar__contact-link">
            <span class="english">Contact us</span>
            <span class="spanish hidden">Contáctenos</span>
          </a>
        </li>

        <!-- Language selector -->
        <li class="myce-utility-bar__action-item myce-lang-dropdown" (focusout)="onLangDropdownFocusout($event)">
          <button #langTrigger type="button" class="myce-utility-bar__icon-btn"
            [attr.aria-expanded]="isLangDropdownOpen" aria-haspopup="listbox" (click)="toggleLangDropdown()"
            (keydown)="onLangKeydown($event)">
            <img src="/assets/images/icons/language-selector.svg" class="myce-utility-bar__icon" aria-hidden="true"
              alt="" />
            <span class="myce-utility-bar__lang-label" [attr.aria-label]="currentLangLabel">{{ currentLangLabel
              }}</span>
          </button>

          <ul #langMenu *ngIf="isLangDropdownOpen" class="myce-utility-bar__dropdown myce-utility-bar__dropdown--lang"
            role="listbox" aria-label="Select language" (keydown)="onLangMenuKeydown($event)">
            <li role="presentation">
              <button type="button" role="option" [attr.aria-selected]="currentLang === 'en'" class="myce-lang-option"
                [class.myce-lang-option--active]="currentLang === 'en'" (click)="onLanguageClick('en')">
                English
              </button>
            </li>
            <li role="presentation">
              <button type="button" role="option" [attr.aria-selected]="currentLang === 'es'" class="myce-lang-option"
                [class.myce-lang-option--active]="currentLang === 'es'" (click)="onLanguageClick('es')">
                Español
              </button>
            </li>
          </ul>
        </li>

        <!-- Log in -->
        <li class="myce-utility-bar__action-item myce-login-dropdown" (focusout)="onLoginDropdownFocusout($event)">
          <button #loginTrigger type="button" class="myce-utility-bar__icon-btn"
            [attr.aria-expanded]="isLoginDropdownOpen" aria-haspopup="menu" (click)="toggleLoginDropdown()"
            (keydown)="onLoginKeydown($event)">
            <img src="/assets/images/icons/login-icon.svg" class="myce-utility-bar__icon" alt="" aria-hidden="true" />
            <span class="myce-utility-bar__lang-label">
              <span class="english">Log in</span>
              <span class="spanish hidden">Iniciar sesión</span>
            </span>
          </button>

          <ul #loginMenu *ngIf="isLoginDropdownOpen"
            class="myce-utility-bar__dropdown myce-utility-bar__dropdown--login" role="menu"
            (keydown)="onLoginMenuKeydown($event)">
            <li *ngFor="let item of loginItems; trackBy: trackByLabel" role="none">
              <a *ngIf="item.isExternal" [href]="item.href" target="_blank" rel="noopener noreferrer" role="menuitem"
                class="myce-utility-bar__dropdown-link">
                <span class="english">{{ item.labelEn }}</span>
                <span class="spanish hidden">{{ item.labelEs }}</span>
              </a>
              <a *ngIf="!item.isExternal && item.routeKey" [routerLink]="('/' + item.routeKey) | langLink"
                [queryParams]="item.queryParams" role="menuitem" class="myce-utility-bar__dropdown-link">
                <span class="english">{{ item.labelEn }}</span>
                <span class="spanish hidden">{{ item.labelEs }}</span>
              </a>
              <a *ngIf="!item.isExternal && !item.routeKey" href="#" (click)="$event.preventDefault()" role="menuitem"
                class="myce-utility-bar__dropdown-link">
                <span class="english">{{ item.labelEn }}</span>
                <span class="spanish hidden">{{ item.labelEs }}</span>
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </nav>
  </div>
</header>